/**
 * Particle prewarm pacing, shared by the ParticleSystem behavior (warming a
 * cloud rebuilt by a capacity edit) and editor/ThumbnailCapture (warming a
 * cloud for a single-frame capture). They differ in step count and in what
 * they do around the burst; this is the part they share.
 */

/** Lifetime (s) assumed for a system that doesn't have a positive one. */
const FALLBACK_LIFETIME = 2;
/** Babylon's default `updateSpeed` (s per step). */
const FALLBACK_STEP_SECONDS = 0.01;

/**
 * The `preWarmStepOffset` that makes a `steps`-step prewarm burst span about
 * one particle lifetime of simulated time, so the oldest particles complete
 * their lifecycle and the cloud reaches steady state.
 *
 * Babylon's prewarm advances `updateSpeed × preWarmStepOffset` seconds per
 * step, so at the default offset of 1 a 120-step burst covers only 1.2 s.
 * Clamped to ≥ 1: a burst never simulates less than Babylon's default step,
 * so a short lifetime gets a longer span, not a shorter one.
 *
 * Neither caller authors `updateSpeed`, so its fallback is defensive.
 */
export function prewarmStepOffsetSpanningLifetime(steps: number, lifetime: number, updateSpeed: number): number {
    const span = lifetime > 0 ? lifetime : FALLBACK_LIFETIME;
    const stepSeconds = updateSpeed > 0 ? updateSpeed : FALLBACK_STEP_SECONDS;
    return Math.max(1, (span / steps) / stepSeconds);
}
